import React, { SyntheticEvent } from 'react';
import { adminUpdateProductVariables } from '@api/graphql/types';
import Input from '@components/Form/Input';
import FormRow from '@components/Form/FormRow';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import DeleteButton from '@components/DeleteButton';
import { ProductFormData } from './ProductEditForm';

interface Props {
    name: keyof ProductFormData;
    value: Array<(string | null)>;
    onChange: (value: Array<(string | null)>, name: keyof adminUpdateProductVariables) => void;
}

interface State {
    categoryToAdd?: string;
}

class ProductCategoryForm extends React.Component<Props & InjectedIntlProps, State> {
    public state = {
        categoryToAdd: '',
    };

    private handleAdd = (e: SyntheticEvent) => {
        const categoryIds = [...this.props.value];
        categoryIds.push(this.state.categoryToAdd!);
        this.props.onChange(categoryIds, this.props.name);
        this.setState({categoryToAdd: undefined});
    }

    private setCategory = (index: number) => (value: string) => {
        const categories = [...this.props.value];
        categories[index] = value;
        this.props.onChange(categories, this.props.name);
    }

    private deleteCategory = (index: number) => {
        const categories = [...this.props.value];
        categories.splice(index, 1);
        this.props.onChange(categories, this.props.name);
    }

    private renderCategoryList = () => {
        const categories = this.props.value.slice(1);
        return categories.map((categoryId: string, index: number) => {
            return (
                <div key={categoryId}>
                    <div className="col-sm-10">
                        <Input type="productcategoryselect" value={categoryId} name={`category_ids-${index}`} onChange={this.setCategory((index + 1))} />
                    </div>
                    <div className="col-sm-2">
                        <DeleteButton className="btn-block"
                            onClick={this.deleteCategory} value={index}
                        />
                    </div>
                </div>
            );
        });
    }

    public render() {
        const defaultCategoryId = (this.props.value[0] || '').toString();
        return (
            <>
                <FormRow label={this.props.intl.formatMessage({id: 'module.product.defaultCategory.label'})}>
                    <div className="col-sm-12">
                        <Input type="productcategoryselect" value={defaultCategoryId} name="category_ids" onChange={this.setCategory(0)} />
                    </div>
                </FormRow>
                {this.props.value.length > 1 &&
                    <FormRow label={this.props.intl.formatMessage({id: 'module.product.categories.label'})}>
                        {this.renderCategoryList()}
                    </FormRow>
                }
                <FormRow label={this.props.intl.formatMessage({id: 'module.product.addCategory.label'})}>
                    <div className="col-sm-10">
                        <Input type="productcategoryselect" value={this.state.categoryToAdd} name="category_ids" onChange={(value) => {
                            this.setState({categoryToAdd: value});
                        }} />
                    </div>
                    <div className="col-sm-2">
                        <button className="btn btn-primary btn-block" disabled={!this.state.categoryToAdd} onClick={this.handleAdd}>{this.props.intl.formatMessage({id: 'common.add'})}</button>
                    </div>
                </FormRow>
            </>
        );
    }
}

export default compose(injectIntl)(ProductCategoryForm);



// WEBPACK FOOTER //
// ./src/modules/Product/components/ProductCategoryForm.tsx